import app from 'flarum/forum/app';
import { extend } from 'flarum/common/extend';
import PostControls from 'flarum/forum/utils/PostControls';
import UserControls from 'flarum/forum/utils/UserControls';
import Button from 'flarum/common/components/Button';

// The ban/unban modals are only needed once a moderator decides to act, so they
// are lazy-loaded into their own chunks rather than shipped in the forum bundle.
const BanIPModal = () => import(/* webpackChunkName: 'common/components/BanIPModal', webpackMode: 'lazy-once' */ '../common/components/BanIPModal');
const UnbanIPModal = () => import(/* webpackChunkName: 'common/components/UnbanIPModal', webpackMode: 'lazy-once' */ '../common/components/UnbanIPModal');
export default function addBanIPControl() {
  extend(PostControls, 'userControls', function (items, post) {
    const user = post && post.user();
    if (!post || !user) return;
    const isBanned = user.isBanned();
    const prefix = isBanned ? 'un' : '';

    // Removes ability to ban thyself and also does permission check.
    if (!post.canBanIP() || post.isHidden() || user === app.session.user || post.contentType() !== 'comment') return;
    items.add("".concat(prefix, "ban"), Button.component({
      icon: 'fas fa-gavel',
      onclick: () => app.modal.show(isBanned ? UnbanIPModal : BanIPModal, {
        post
      })
    }, app.translator.trans("fof-ban-ips.forum.".concat(prefix, "ban_ip_button"))));
  });
  extend(UserControls, 'moderationControls', function (items, user) {
    if (!user.canBanIP() || user === app.session.user) return;
    const isBanned = user.isBanned();
    const prefix = isBanned ? 'un' : '';
    items.add("".concat(prefix, "ban"), Button.component({
      icon: 'fas fa-gavel',
      onclick: () => app.modal.show(isBanned ? UnbanIPModal : BanIPModal, {
        user
      })
    }, app.translator.trans("fof-ban-ips.forum.user_controls.".concat(prefix, "ban_button"))));
  });
}flarum.reg.addChunkModule('625', '293', 'fof-ban-ips', 'common/components/BanIPModal');
flarum.reg.addChunkModule('648', '144', 'fof-ban-ips', 'common/components/UnbanIPModal');